import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  key: 1,
  class: "max-w-xl"
};
const _hoisted_2 = {
  key: 2,
  class: "w-full flex flex-col gap-6"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "text-main-100 font-medium"
};
const _hoisted_5 = {
  key: 0,
  class: "icon-check text-xs text-second-100 ml-auto"
};
const _hoisted_6 = {
  key: 1,
  class: "flex flex-col gap-6 animate-fade"
};
const _hoisted_7 = {
  class: "flex items-center gap-2"
};
const _hoisted_8 = {
  class: "w-full flex items-center justify-between gap-4"
};
const _hoisted_9 = {
  class: "w-fit flex items-center gap-3 py-2 px-6 rounded-3xl bg-main-5/10"
};
const _hoisted_10 = {
  class: "font-medium"
};
const _hoisted_11 = {
  class: "flex items-center gap-3"
};
const _hoisted_12 = {
  key: 1,
  class: "contents"
};
const _hoisted_13 = {
  key: 0,
  class: "contents"
};
const _hoisted_14 = {
  key: 0,
  class: "w-full grid md:grid-cols-2 xl:grid-cols-3 gap-2.5 px-1.5 overflow-hidden"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "flex items-center gap-3"
};
const _hoisted_17 = {
  class: "truncate font-medium"
};
const _hoisted_18 = {
  class: "action-elements flex items-center gap-2 ml-auto"
};
const _hoisted_19 = {
  class: "flex items-center gap-2 justify-between text-main-50 text-2xs"
};
const _hoisted_20 = {
  key: 2,
  class: "contents"
};
const _hoisted_21 = {
  key: 0,
  class: "flex gap-2"
};
const _hoisted_22 = {
  class: "w-fit flex items-center gap-4 text-xs"
};
const _hoisted_23 = {
  class: "flex items-center gap-6 py-2 px-4 rounded-3xl bg-second-100/30 border-2 border-second-100/10"
};
const _hoisted_24 = {
  key: 0,
  class: "flex items-center gap-2"
};
const _hoisted_25 = {
  key: 1,
  class: "contents"
};
const _hoisted_26 = {
  class: "flex items-center gap-2"
};
const _hoisted_27 = {
  class: "w-full grid md:grid-cols-2 xl:grid-cols-3 gap-x-4 gap-y-4 animate-fade"
};
const _hoisted_28 = {
  key: 0,
  class: "h-[110px] w-full flex items-center justify-center flex-col gap-3 text-center rounded-xl bg-main-5/10 text-xs font-medium p-3 text-main-50 order-first"
};
const _hoisted_29 = {
  key: 1,
  class: "h-[110px] w-full flex items-center justify-center flex-col gap-3 text-center rounded-xl bg-main-5/10 text-xs font-medium p-3 text-main-50"
};
const _hoisted_30 = ["onClick"];
const _hoisted_31 = {
  class: "h-full w-full flex flex-col gap-3 p-6 border-b border-main-50/20"
};
const _hoisted_32 = {
  class: "flex items-center gap-3"
};
const _hoisted_33 = {
  class: "font-semibold truncate"
};
const _hoisted_34 = {
  class: "flex items-center gap-1.5 right-3 top-3 empty:hidden! ml-auto pl-4"
};
const _hoisted_35 = {
  key: 0,
  class: "contents"
};
const _hoisted_36 = {
  key: 0,
  class: "icon-refresh text-lg text-cta-75"
};
const _hoisted_37 = {
  key: 1,
  class: "flex items-center gap-2"
};
const _hoisted_38 = {
  class: "text-xs"
};
const _hoisted_39 = {
  class: "w-full flex flex-wrap gap-2 py-2.5 px-5 text-xs bg-main-50/10"
};
const _hoisted_40 = {
  class: "flex items-center gap-2 bg-main-50/20 py-1 px-3 rounded-3xl"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
                                                                                  
                                                                        
                                                      
  const _component_Button = _resolveComponent("Button");
  const _component_Toggle = _resolveComponent("Toggle");
  const _component_s_info_card = _resolveComponent("s-info-card");
                                                        
  const _directive_ptooltip = _resolveDirective("ptooltip");
  return _ctx.loading ? (_openBlock(), _createBlock(_component_v_progress_circular, {
    key: 0,
    size: "40",
    width: "4",
    indeterminate: ""
  })) : $props.selectable ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_autocomplete, {
    label: $options.SelectorConfig.label,
    items: _ctx.loadedData,
    "prepend-inner-icon": "icon-certificate text-xl mr-3",
    "item-title": "name",
    "return-object": "",
    chips: "",
    loading: _ctx.loading,
    disabled: _ctx.loading,
    multiple: false,
    modelValue: _ctx.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _ctx.value = $event),
    density: "comfortable",
    "hide-details": "",
    "no-data-text": $options.SelectorConfig.noItems,
    variant: "outlined"
  }, null, 8, ["label", "items", "loading", "disabled", "modelValue", "no-data-text"])])) : _ctx.loadedData?.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [$options.computedType.certificates ? (_openBlock(), _createBlock(_component_v_autocomplete, {
    key: 0,
    class: "w-full max-w-lg",
    label: "Buscar certificado",
    "custom-filter": $options.CustomCertificateSearchFilter,
    items: $options.CertificatesList,
    "prepend-inner-icon": "icon-search text-lg mr-3",
    chips: "",
    "hide-details": "",
    "no-data-text": $options.SelectorConfig.noItems,
    density: "comfortable",
    variant: "outlined"
  }, {
    item: _withCtx(({
      item
    }) => [_withDirectives((_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["flex items-center text-xs gap-2 py-3 px-4 cursor-pointer truncate text-main-75 hover:bg-main-100/5 transition-colors", {
        '!bg-second-10': item.value.selected
      }]),
      onClick: _withModifiers($event => $options.ToggleCertificateSelection(item.value), ["stop"])
    }, [_createElementVNode("span", {
      class: _normalizeClass({
        '!text-cta-75': !item.value.machine?.shared
      })
    }, _toDisplayString(item.value.machineName), 3), _cache[4] || (_cache[4] = _createTextVNode(" / ")), _createElementVNode("span", _hoisted_4, _toDisplayString(item.value.normalizedName), 1), item.value.selected ? (_openBlock(), _createElementBlock("i", _hoisted_5)) : _createCommentVNode("", true)], 10, _hoisted_3)), [[_directive_ripple]])]),
    _: 1
  }, 8, ["custom-filter", "items", "no-data-text"])) : _createCommentVNode("", true), _ctx.selectedMachine ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_v_btn, {
    onClick: _cache[1] || (_cache[1] = $event => _ctx.selectedMachine = undefined),
    icon: "icon-previous",
    variant: "text",
    size: "small"
  }), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_cache[5] || (_cache[5] = _createElementVNode("i", {
    class: "icon-desktop text-sm"
  }, null, -1)), _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.selectedMachine.name), 1)]), _createElementVNode("div", _hoisted_11, [!$props.readonly && _ctx.multiple ? (_openBlock(), _createBlock(_component_v_btn, {
    key: 0,
    variant: "outlined",
    text: "Seleccionar todos",
    "append-icon": "icon-check text-xs",
    onClick: _cache[2] || (_cache[2] = $event => $options.ToggleMachineCertificates(_ctx.selectedMachine))
  })) : _createCommentVNode("", true), _ctx.selectedMachine.local && $props.readonly ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_ctx.selectedMachine.sync ? _withDirectives((_openBlock(), _createBlock(_component_Button, {
    key: 0,
    text: "Desincronizar certificados y eliminar dispositivo",
    icon: "icon-broken-link",
    reversed: true,
    variant: "tinted",
    size: "sm",
    onClick: _cache[3] || (_cache[3] = $event => $options.RemoveMachine(_ctx.selectedMachine))
  }, null, 512)), [[_directive_ripple]]) : _withDirectives((_openBlock(), _createBlock(_component_Button, {
    key: 1,
    text: "Sincronizar certificados en mi entorno de trabajo",
    icon: "icon-www",
    reversed: true,
    variant: "tinted",
    size: "sm",
    onClick: $options.SyncDigitalCertificates
  }, null, 8, ["onClick"])), [[_directive_ripple]])])) : _createCommentVNode("", true)])])]), $options.computedType.certificates ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_ctx.selectedMachine.certificates?.length ? (_openBlock(), _createElementBlock("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedMachine.certificates, (certificate, certIndex) => {
    return _openBlock(), _createElementBlock("div", {
      key: certificate,
      class: "w-full flex flex-col gap-3 bg-main-10 rounded-xl p-3.5 text-main-100 text-xs opacity-0 animate-popup duration-500 cursor-pointer border-2 border-transparent hover:border-second-100 hover:bg-second-5 transition-colors overflow-hidden",
      style: _normalizeStyle(`animation-delay: ${certIndex * 40}ms; animation-fill-mode: forwards`),
      onClick: $event => $options.ToggleCertificateSelection(certificate)
    }, [_createElementVNode("div", _hoisted_16, [_cache[6] || (_cache[6] = _createElementVNode("i", {
      class: "icon-certificate text-lg"
    }, null, -1)), _createElementVNode("p", _hoisted_17, _toDisplayString(certificate.normalizedName), 1), _createElementVNode("div", _hoisted_18, [!$props.readonly ? (_openBlock(), _createBlock(_component_Toggle, {
      key: 0,
      modelValue: certificate.selected,
      "onUpdate:modelValue": $event => certificate.selected = $event
    }, null, 8, ["modelValue", "onUpdate:modelValue"])) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_19, [_createElementVNode("p", null, "Caduca: " + _toDisplayString(new Date(certificate.notAfter).toLocaleDateString('es-ES')), 1), _createElementVNode("p", null, _toDisplayString(certificate.nifVat), 1)])], 12, _hoisted_15);
  }), 128))])) : (_openBlock(), _createBlock(_component_s_info_card, {
    key: 1,
    title: "Este dispositivo no tiene certificados compartidos",
    icon: "icon-certificate cross-bar"
  }))])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_20, [$options.SelectedCertificates?.length ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [$options.SelectedCertificates.length > 1 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_cache[7] || (_cache[7] = _createElementVNode("i", {
    class: "icon-click text-sm"
  }, null, -1)), _createTextVNode(" " + _toDisplayString($options.SelectedCertificates.length) + " certificados seleccionados ", 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_25, [_cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "flex items-center gap-2"
  }, [_createElementVNode("i", {
    class: "icon-click text-sm"
  }), _createTextVNode(" Certificado seleccionado ")], -1)), _createElementVNode("div", _hoisted_26, [_cache[8] || (_cache[8] = _createElementVNode("i", {
    class: "icon-certificate text-sm"
  }, null, -1)), _createTextVNode(" " + _toDisplayString($options.SelectedCertificates[0].machine?.name ?? '?') + "  •  " + _toDisplayString($options.SelectedCertificates[0].normalizedName), 1)])]))])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_27, [!_ctx.$embedded && $options.computedType.certificates ? (_openBlock(), _createElementBlock("div", _hoisted_28, _cache[10] || (_cache[10] = [_createElementVNode("i", {
    class: "icon-desktop text-xl"
  }, null, -1), _createTextVNode(" Certificados locales no disponibles ")]))) : _createCommentVNode("", true), !$options.ThereAreShared ? (_openBlock(), _createElementBlock("div", _hoisted_29, _cache[11] || (_cache[11] = [_createElementVNode("i", {
    class: "icon-www text-xl"
  }, null, -1), _createTextVNode(" No hay compartidos en tu entorno de trabajo ")]))) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.loadedData, folder => {
    return _openBlock(), _createElementBlock("div", {
      key: folder,
      class: _normalizeClass(["relative group w-full bg-main-5 flex flex-col rounded-xl text-main-100 shadow-material cursor-pointer overflow-hidden", {
        'order-first': folder.local
      }]),
      onClick: $event => _ctx.selectedMachine = folder
    }, [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createElementVNode("i", {
      class: _normalizeClass(["text-xl", [{
        'icon-desktop text-cta-100': folder.local
      }, {
        'icon-www': !folder.local
      }]])
    }, null, 2), _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.texts.machineLabel(folder)), 1), _createElementVNode("div", _hoisted_34, [folder.local ? (_openBlock(), _createElementBlock("div", _hoisted_35, [folder.sync ? _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_36, null, 512)), [[_directive_ptooltip, `Dispositivo sincronizado como ${folder.savedAs}`]]) : (_openBlock(), _createBlock(_component_v_btn, {
      key: 1,
      text: "Sincronizar dispositivo",
      variant: "tonal",
      size: "x-small",
      "prepend-icon": "icon-www text-xs",
      onClick: _withModifiers($options.SyncDigitalCertificates, ["stop"])
    }, null, 8, ["onClick"]))])) : folder.accessData ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("p", _hoisted_38, _toDisplayString(folder.accessData.text), 1), _createElementVNode("div", {
      class: _normalizeClass(["h-3 w-3 rounded-full shrink-0", folder.accessData.statusColor])
    }, null, 2)])), [[_directive_ptooltip, folder.accessData.tooltip]]) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_cache[12] || (_cache[12] = _createElementVNode("i", {
      class: "icon-certificate text-sm"
    }, null, -1)), _createTextVNode(" " + _toDisplayString(_ctx.texts.machineCertificatesSubtitle(folder)), 1)]), _cache[13] || (_cache[13] = _createElementVNode("i", {
      class: "icon-next text-base ml-auto opacity-0 group-hover:opacity-100 transition-opacity"
    }, null, -1))])], 10, _hoisted_30);
  }), 128))])]))])) : (_openBlock(), _createBlock(_component_s_info_card, {
    key: 3,
    title: $options.NoCertsText,
    icon: "icon-search cross-bar"
  }, null, 8, ["title"]));
}

/* Vuetify */
import { VAutocomplete as _component_v_autocomplete } from "vuetify/components/VAutocomplete"
import { VBtn as _component_v_btn } from "vuetify/components/VBtn"
import { VProgressCircular as _component_v_progress_circular } from "vuetify/components/VProgressCircular"
import { Ripple as _directive_ripple } from "vuetify/directives"

